import React from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import OnboardingRadioButton from "../shared/components/formik/radiobutton";
import { useMessageSource } from "react-message-source";
import Typography from "../../ui/widgets/typography";
import { RadioButtonItem } from "../../ui/widgets/radiobutton/types";
import { BasicAccountBenefitsModel } from "./types";
import { ScdAccordion } from "../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../ui/widgets/accordion/details";

const CustomizationCardOptions = (): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  const radioButtonOptions: RadioButtonItem[] = [
    {
      id: "customizedCard",
      value: "NONE" as BasicAccountBenefitsModel["customizedCard"],
      label: getMessage("YesNo.NO"),
    },
    {
      id: "customizedCard",
      value:
        "PICTURE_OR_LOGO_ON_CARD" as BasicAccountBenefitsModel["customizedCard"],
      label: getMessage(
        "CustomizationCardOptions.checkbox.picture-on-card-option",
      ),
    },
    {
      id: "customizedCard",
      value: "LOGO_ON_CARD" as BasicAccountBenefitsModel["customizedCard"],
      label: getMessage(
        "CustomizationCardOptions.checkbox.logo-on-card-option",
      ),
    },
  ];

  return (
    <>
      <div className="scd-section-helper-lg">
        <RadioButtonContainer>
          <OnboardingRadioButton
            title={getMessage("CustomizationCardOptions.checkbox")}
            id="customizedCard"
            name="customizedCard"
            values={radioButtonOptions}
          />
        </RadioButtonContainer>
      </div>

      <ScdAccordion>
        <ScdAccordionSummary>
          <Typography variant="body2">
            {getMessage("CustomizationCardOptions.Notes.title")}
          </Typography>
        </ScdAccordionSummary>
        <ScdAccordionDetails>
          <div className="scd-column-text">
            {getMessage("CustomizationCardOptions.Notes.text")}
          </div>
        </ScdAccordionDetails>
      </ScdAccordion>
    </>
  );
};

export default CustomizationCardOptions;
